<div class="summary-items-container"></div>
